import axios from "axios";
import { API_BASE_URL } from "../config/api";
import { getCookie, getAuthToken } from "../utils/cookieUtils";

/**
 * DealVoice Centralized Axios Client
 * Automatically attaches Authorization JWT token from cookies and active tenant company code.
 */
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 90000,
});

// Request Interceptor: Attach Auth Token & Company Code
apiClient.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token && !config.headers["Authorization"]) {
      config.headers["Authorization"] = token.startsWith("Bearer ")
        ? token
        : `Bearer ${token}`;
    }

    const companyCode =
      config.headers["x-active-company-code"] ||
      config.params?.companyCode ||
      config.data?.companyCode ||
      getCookie("companyCode");

    if (companyCode && !config.headers["x-active-company-code"]) {
      config.headers["x-active-company-code"] = companyCode;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor: Unpack data and normalize error structures
apiClient.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    const status = error.response?.status;
    const responseData = error.response?.data;
    const errorMessage =
      responseData?.message ||
      responseData?.error ||
      error.message ||
      "An unexpected error occurred.";

    return Promise.reject({
      success: false,
      status,
      message: errorMessage,
      data: responseData,
      ...responseData,
    });
  }
);

export default apiClient;
